import { GenericLazyString } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Divider from '../../../divider/Divider';
import TextInput from '../../../textInput/TextInput';
import { useTheme } from '../../../theme-context';

interface IGeneralAdmissionLine {
    info: {
        ticketName: string;
        price: string | GenericLazyString;
        quantity: string;
        variantId: string;
        complimentaryOrder: boolean;
    };
    setTicketQuantityAction: (id: string, quantity: string) => void;
}

const GeneralAdmissionLine = ({
    info,
    setTicketQuantityAction,
}: IGeneralAdmissionLine): React.ReactElement => {
    const { complimentaryOrder, price, quantity, ticketName, variantId } =
        info || {};
    const { getFont } = useTheme();

    return (
        <div>
            <Divider />

            <div
                className={css({
                    display: 'grid',
                    gridTemplateColumns: 'auto fit-content(100%)',
                    alignContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px',
                    margin: '1px',
                })}
            >
                <div>
                    <p
                        className={css({
                            fontFamily: getFont('desktop/body/medium/bold')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium/bold')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium/bold')
                                .fontSize,
                            marginBottom: '4px',
                        })}
                    >
                        {ticketName}
                    </p>
                    {complimentaryOrder ? (
                        ''
                    ) : (
                        <p className="eds-text-bm">{price}</p>
                    )}
                </div>
                <div
                    data-testid="ticket-quantity"
                    className={css({
                        float: 'left',
                        alignSelf: 'center',
                        width: '48px',
                        justifySelf: 'self-end',
                        fontFamily: getFont('desktop/body/medium').fontFamily,
                        fontWeight: getFont('desktop/body/medium').fontWeight,
                        fontSize: getFont('desktop/body/medium').fontSize,
                    })}
                >
                    <TextInput
                        placeholder="0"
                        onChange={(value) =>
                            setTicketQuantityAction(variantId, value)
                        }
                        value={(quantity || '').toString()}
                    />
                </div>
            </div>
        </div>
    );
};

export default GeneralAdmissionLine;
